export const allPeopleFolderId = 'allPeople';
export const allListsFolderId = 'allLists';
export const groupsFolderId = 'groups';
